import { r as registerInstance, h, H as Host } from './index-2b2e631a.js';
import { g as getFieldValue } from './utils-38fbbd70.js';
import './state-3cc1e9a3.js';

let SearchResultPGCourse = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  /**
   * Render element
   */
  render() {
    // Return element
    return (h(Host, { class: "search-result__inner" }, h("div", { class: "search-result__taxonomy" }, h("div", { class: "badge" }, getFieldValue(this.searchResult.Fields, 'StudyType'), " postgraduate programme")), h("slot", null), h("div", { class: "search-result__meta" }, h("dl", null, h("dt", null, "Modes of study"), h("dd", null, getFieldValue(this.searchResult.Fields, 'StudyModes')), h("dt", null, "Awards available"), h("dd", null, getFieldValue(this.searchResult.Fields, 'CourseAwards'))))));
  }
};

export { SearchResultPGCourse as search_result_pg_course };
